/** A tenant's code (owner 2026-10-21): a lowercase DNS label -- the dashboard address
 *  `<code>.dashboard.curatedplanet.com` (staging `<code>.dashboard-staging.curatedplanet.com`;
 *  backend DASHBOARD_BASE_URL_TEMPLATE) and the MCP URL's path segment -- and read-only once the
 *  tenant exists. `TourOperatorCreateInput.code` in console.openapi.yaml. */
export const TENANT_CODE_RE = /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/;

/** The backend's create refusal, word for word. */
export const TENANT_CODE_RULE =
  'Code must be 1-63 characters of a-z, 0-9 or -, starting and ending with a letter or digit.';

export const isTenantCode = (code: string): boolean => TENANT_CODE_RE.test(code);

/** What a code input keeps of what is typed: lowercase letters, digits and `-`. */
export const tenantCodeInput = (typed: string): string =>
  typed.toLowerCase().replace(/[^a-z0-9-]/g, '');
